
import { SideMenuItems, HTTPResponse, ToastMessageType } from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import { AppContext } from "../../Contexts/AppContextProvider";
import React, { useContext, useEffect } from "react";
import { CommonError_Msgs } from "../../Helpers/HelperText";
import { GetLocalStorageData, GetLoggedInUserID, AddLocalStorageData, applySidebarState, toggleSidebar } from "../../Helpers/Utilities";
import { PatientService } from "../../WebApiServices/Patient.service";

const PatientScreening = () => {
  const navigatePaths = {
    prevPage: "/AbbreviationList",
    currPage: "/PatientScreening",
    nextPage: "/EligibilityCriteria",
  };


  const { ShowToast,ToggleLoader,  isSideMenuActive, setisSideMenuActive } = useContext(AppContext);
    const userId = GetLoggedInUserID() ?? 0;
    let patientData = GetLocalStorageData("patient")
    patientData = patientData && JSON.parse(patientData);

    const patientID = patientData?.patientId ?? 0;


    const SaveForm = async () => {
        try {
            if (patientID === 0)
                return await AddNewPatient();
            else {
                return true;
            }
        } catch {

        }
    }  /* <summary>
date: 25-02-2025
Name: BV
description: Save New Patient 
<summary>*/
    const AddNewPatient = async () => {
        try {

            ToggleLoader(true)
            const payload = {
                AbstractorId: userId
            }
            const response = await PatientService.SavePatient(payload);
            if (response?.status === HTTPResponse.OK) {
                AddLocalStorageData("patientId", response?.data?.patientId)
             
                const ptArr = {
                    patientId: response?.data?.patientId ?? 0,
                    uniqueEncryptedPatientId: response?.data?.uniqueEncryptedPatientId ?? 0,
                    surveyDate: response?.data?.abstractionDate ?? "",
                    locked: false,
                    part2locked: false,
                    ptCenterId: response?.data?.siteId ?? 0,
                    abstractorId: response?.data?.abstractorId ?? 0,
                    canEdit: true
                };
                AddLocalStorageData("patient", JSON.stringify(ptArr))

                ToggleLoader(false)
                ShowToast("Patient has been saved successfully", ToastMessageType.Success);
                return true;
            } else {
                throw response.error;
            }
        } catch {
            ToggleLoader(false)
            ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
        }
    }

  


  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);


  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
                      <SaveAndNavigate paths={navigatePaths} Save={SaveForm} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div >
          <SideBarMenu activePageId={SideMenuItems.PatientScreening} />
          <>
            <button className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() => toggleSidebar(isSideMenuActive, setisSideMenuActive)}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>** PATIENT SCREENING</h4>
              </div>

              <div className="survey-introduction-section">
                <div className="survey-introduction-content survey-content-box">
                  <div className="instructions">
                    <div>
                        Please note that:{" "}
                      <p  className="margin-align">
                        <ul>
                        <li>Patients can be <b>living or deceased</b> to be included in the study</li>
                        <li>Patients can be <b>currently or not currently receiving care</b> at your site to be included in the study</li>
                        <li>This is a <b>retrospective, non-interventional study</b>; all data collected for patients should be reported for the patient on or before the date of chart abstraction</li>
                        <li>A patient’s chart must <b>satisfy all eligibility criteria listed below</b> to be eligible for data extraction:</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                  <div className="important-note">
                    <b className="important-note-title">Inclusion Criteria</b>
                    <br />
                    <span className="important-note-description">
                   <ul><li>Patients are required to <u>meet all</u> the following criteria:</li></ul> 
                    </span>
                    <ul className="important-note-list margin-align">
                      <p className="important-note-item">
                      At least one piece of evidence (e.g., patient medical record, genetic testing, etc.) indicating MMA diagnosis within the patient’s medical record
                      </p>
                      <p className="important-note-item">
                      Genetic testing showing deficiency of the methylmalonyl-CoA mutase (<i>mut</i>) enzyme (<i>mut<sup>0</sup> or mut<sup>-</sup></i>)
                      </p>
                      <p className="important-note-item">
                      Indication that the patient received a liver transplant (LT), either in isolation or as part of a combined or sequential liver-kidney transplant (LKT) 
                      </p>
                    </ul>
                    <p>
                      <ul>
                        <li className="important-note-item-circle" >
                        The <b>index date</b> will be defined as the date of the LT procedure
                        </li>

                        <li className="important-note-item-square">
                        If a patient received a combined LKT, it is expected that the liver and kidney transplants occurred on the same date; please index on this date
                        </li>
                        <li className="important-note-item-square">
                        If a patient received a sequential LKT (e.g., liver and kidney transplants on differing dates), please index on the date of liver transplant
                        </li>
                      </ul>

                    </p>
                  </div>

                  <div className="important-note">
                    <b className="important-note-title">Exclusion Criteria</b>
                    <br />
                    <p className="margin-align">
                        <ul>
                        <li>Patients will be excluded if <u>having any</u> of the following:</li>
  
                        </ul>
                      </p>
                     
                    <p className="important-note-list" > 
                      <li className="important-note-item">
                        MMA due to a non-mutase enzyme deficiency subtype, including but not limited to cobalamin-related subtypes (e.g., cblA, cblB, cblD) or MMA due to methylmalonyl-CoA epimerase deficiency
                      </li>
                      <li className="important-note-item">
                      Patients with MMA due to <i>mut</i> enzyme deficiency combined with homocystinuria
                      </li>
                      <li className="important-note-item">
                      Unsuccessful LT or LKT procedure, defined as:
                      </li>
                        <ul className="">
                           <li className="align-items-text-circle">
                           Never discharged from transplant-related hospitalization admission
                           </li>
                           <li className="align-items-text-circle">
                           Liver re-transplantation
                           </li> 
                           <li className="align-items-text-square" style={{marginTop: "8px"}}>
                           <b>Note:</b> patients with re-transplantation of other organs (not liver) will be included in the study if satisfying all other patient eligibility criteria
                           </li>
                        </ul>
                        
               
                      <li className="important-note-item "style={{marginTop: "8px"}}>
                                              Enrollment in clinical trial for the treatment of MMA <u style={{ lineHeight: "2px" }}>prior to the index date</u>
                      </li>
                       <ul>
                       <li className="align-items-text-circle">
                      <b>Note:</b> if the patient enrolled into a clinical trial for the treatment of MMA <u style={{lineHeight: "2px"}}><i>after</i></u> their index date, all record collection will be censored at the date of trial enrollment
                        </li>
                       </ul>
                      
                    </p>
                  </div>

                  <br />
                </div>
              </div>
              <div className="survey-section-content-foot">
                              <SaveAndNavigate paths={navigatePaths} Save={SaveForm} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PatientScreening;
